export const useWeightData = () => {
    // Mock data for weight tracking
    const goalWeights = [85, 84, 83, 82, 81, 80, 79, 78, 77, 76, 75, 74, 73, 72, 71, 70]; // Long goal array
    const actualWeights = [85, 87, 86];

    return {
        goalWeights,
        actualWeights,
    };
}; 